export const BLOCKCHAINS = [
  {
    value: 'binance-smart-chain',
    label: 'BSC',
    apiKey: 'BSC'
  },
  {
    value: 'ethereum',
    label: 'Ethereum',
    apiKey: 'ETH'
  },
  {
    value: 'polygon-pos',
    label: 'Polygon',
    apiKey: 'MATIC'
  },
  {
    value: 'avalanche',
    label: 'Avalanche',
    apiKey: 'AVAX'
  },
  {
    value: 'base',
    label: 'Base',
    apiKey: 'BASE'
  },
  {
    value: 'arbitrum-one',
    label: 'Arbitrum',
    apiKey: 'ARB'
  },
  {
    value: 'zksync-era',
    label: 'ZkSync Era',
    apiKey: 'ZK'
  }
];
